module.exports = __webpack_public_path__ + "static/img/gray-laptop-computer-showing-html-codes-in-shallow-focus-160107.44af6388.jpg";